import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';


const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-V2-U3-P24-E1',
    audio: 'img/FriendsPlus/Page24/Audio/audio-e1-p24.mp3',
    video: '',
    component: UI,
    recorder: true,
    // exerciseKey: '',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page24/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/tieude-e1-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E1/4.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh1-e1-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page24/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh2-e1-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page24/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh3-e1-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page24/E1/10.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh4-e1-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page24/E1/12.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/hinh5-e1-p24.mp3' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E1/13.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-V2-U3-P24-E2',
    audio: '',
    video: '',
    component: UI,
    // exerciseKey: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E2/2.jpg' },
      ],

    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-V2-U3-P24-E3',
    audio: 'img/FriendsPlus/Page24/Audio/audio-e3-p24.mp3',
    video: '',
    component: UI,
    recorder: true,
    // exerciseKey: '',
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E3/1.jpg' },
        { url: 'img/FriendsPlus/Page24/E3/2.jpg', audioUrl: 'img/FriendsPlus/Page24/Audio/tieude-e3-p24.mp3' },
        { url: 'img/FriendsPlus/Page24/E3/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E3/4.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 3',
    id: 'SB5-V2-U3-P24-E4',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    exerciseKey: 'img/FriendsPlus/Page24/E4/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page24/E4/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E3/4.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page24/E4/2.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/3.jpg', input: true, answer: "Anh" },
        { url: 'img/FriendsPlus/Page24/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page24/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/6.jpg', input: true, answer: "Anh" },
        { url: 'img/FriendsPlus/Page24/E4/7.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/8.jpg', input: true, answer: "Trang" },
        { url: 'img/FriendsPlus/Page24/E4/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page24/E4/10.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/11.jpg', input: true, answer: "Trang" },
        { url: 'img/FriendsPlus/Page24/E4/12.jpg' },
        { url: 'img/FriendsPlus/Page24/E4/13.jpg', input: true, answer: "Anh" },
        { url: 'img/FriendsPlus/Page24/E4/14.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page24/E4/15.jpg' },

      ],


    ],
  },


}

export default json;